import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getThreads, getThreadMessages, deleteThread, setCurrentThread } from '../../store/Assistant/index';

const ThreadHistory = ({ setShowHistory, onNewChat }) => {
  const dispatch = useDispatch();

  const { threads, threadsLoading, currentThreadId } = useSelector(state => state['Assistant']);

  useEffect(() => {
    dispatch(getThreads());
  }, []);

  const handleSelectThread = (threadId) => {
    dispatch(setCurrentThread(threadId));
    dispatch(getThreadMessages(threadId));
    // Clear localStorage when selecting a thread from history
    localStorage.removeItem('assistant_current_threadId');
    setShowHistory(false);
  };

  const handleDeleteThread = (e, threadId) => {
    e.stopPropagation();
    if (window.confirm('Are you sure you want to delete this conversation?')) {
      dispatch(deleteThread(threadId));
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else if (diffDays < 7) {
      return date.toLocaleDateString('en-US', { weekday: 'long' });
    } else {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
  };

  const groupThreadsByDate = (threads) => {
    const grouped = {};

    threads.forEach(thread => {
      const date = new Date(thread['lastMessageAt'] || thread['createdAt']);
      const dateKey = date.toDateString();

      if (!grouped[dateKey]) {
        grouped[dateKey] = {
          date: date,
          displayDate: formatDateHeader(date),
          threads: []
        };
      }

      grouped[dateKey]['threads'].push(thread);
    });

    return Object.values(grouped).sort((a, b) => b['date'] - a['date']);
  };

  const formatDateHeader = (date) => {
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    }
  };

  // if (threadsLoading) {
  //   return (
  //     <div className='history-sidebar'>
  //       <div className='sidebar-header'>
  //         <h3>Conversations</h3>
  //         <button className='btn-style-new' onClick={onNewChat}>
  //           + New Chat
  //         </button>
  //       </div>
  //       <div className='loading'>Loading conversations...</div>
  //     </div>
  //   );
  // }

  const groupedThreads = groupThreadsByDate(threads);

  return (
    <div className='history-sidebar'>
      {/* <div className='sidebar-header'>
        <h3>Conversations</h3>
        <button className='btn-style-new' onClick={onNewChat}>
          + New Chat
        </button>
      </div> */}

      <div className='history-content'>
        {groupedThreads.length === 0 ? (
          <div className='no-threads'>
            <p>No conversations yet</p>
            <p className='hint'>Start a new chat to begin</p>
          </div>
        ) : (
          groupedThreads.map((group, groupIndex) => (
            <div key={groupIndex} className='date-history-box'>
              <h5>{group['displayDate']}</h5>
              {group['threads'].map(thread => (
                <div key={thread['threadId']} className={`history-box ${currentThreadId === thread['threadId'] ? 'active' : ''}`}
                  onClick={() => handleSelectThread(thread['threadId'])}>
                  <div className='left-text-area'>
                    <h3>{thread['title'] || 'New Conversation'}</h3>
                    <p>{formatDate(thread['lastMessageAt'] || thread['createdAt'])}</p>
                  </div>
                  <div className='thread-meta'>
                    <button
                      className='delete-btn'
                      onClick={(e) => handleDeleteThread(e, thread['_id'])}
                      title='Delete conversation'>
                      <i className='icon'><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeleteIcon"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"></path></svg></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ThreadHistory;